import { HAS_WINDOW_LISTENERS } from '@eventbrite/feature-detection';

import { FunctionComponent, useEffect } from 'react';
import { InitialExperimentPostPaymentQuestionsVariant } from '../../constants/statsig';
import { getInitialExperimentpostPaymentQuestionsValue } from '../../utils/statsig';

const shouldShowCloseAlertByVariant = {
    [InitialExperimentPostPaymentQuestionsVariant.newDesignOneButton]: true,
    [InitialExperimentPostPaymentQuestionsVariant.newDesignTwoButtons]: true,
    [InitialExperimentPostPaymentQuestionsVariant.oldDesign]: false,
};

export interface LeaveCheckoutWarningProps {
    abandonOrderOnClose: () => void;
    performTabless: boolean;
}

export const LeaveCheckoutWarning: FunctionComponent<
    LeaveCheckoutWarningProps
> = ({ abandonOrderOnClose, performTabless }) => {
    const variant = getInitialExperimentpostPaymentQuestionsValue();
    const shouldShowCloseAlert = shouldShowCloseAlertByVariant[variant];

    useEffect(() => {
        if (!HAS_WINDOW_LISTENERS || performTabless) {
            return;
        }

        const _handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (!shouldShowCloseAlert) {
                return;
            }
            e.preventDefault();
            e.returnValue = '';
        };

        const _handleUnload = async () => {
            abandonOrderOnClose();
        };

        window.addEventListener('beforeunload', _handleBeforeUnload);
        window.addEventListener('unload', _handleUnload);

        return () => {
            window.removeEventListener('beforeunload', _handleBeforeUnload);
            window.removeEventListener('unload', _handleUnload);
        };
    }, [performTabless, shouldShowCloseAlert, abandonOrderOnClose]);

    return null;
};
